module.exports = __webpack_public_path__ + "static/img/m-bg.fe48180f.png";